import moment from "moment";
import StringUtils from "./StringUtils";

export default class DateUtils {
    static isValidDate(input) {
        const date = moment(input).toDate();
        return input !== null && !isNaN(date.getTime())
    }
    static dateFromString(value){
        let date = value;
        if(StringUtils.isString(date)){
            return moment(date).toDate();
        }
        return date;
    }
}